import { ObjectType } from '@ru-edu/ecl-player';
import { List } from './List';

export const LessonList = () => <List kind={ObjectType.Lesson} baseUrl="/lessons" />;
